import { useEffect, useState } from "react";
import useActivityLogger from "../hooks/useActivityLogger";

export default function ActivityTracker({ userId }) {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    setActiveId(userId || null);
  }, [userId]);

  useActivityLogger(activeId);

  return null;
}
